import * as AREAS from './constants'

export const SET_AREA = 'SET_AREA'
export const SHOW_AREA_SELECT = 'SHOW_AREA_SELECT'
export const HIDE_AREA_SELECT = 'HIDE_AREA_SELECT'

const areas = [AREAS.FINLAND, AREAS.ENGLAND, AREAS.NORTHERN_IRELAND, AREAS.IRELAND, AREAS.SCOTLAND, AREAS.WALES, AREAS.USA, AREAS.ESTONIA];

const actions = {
    setArea: (area, showAreaSelect = undefined) => ({
        type: SET_AREA,
        payload: {
        area,
        showAreaSelect
        }
    }),
    showArea: () => ({
        type: SHOW_AREA_SELECT
    }),
    hideArea: () => ({
        type: HIDE_AREA_SELECT
    })
}

const getUrlParameter = (name) => {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? false : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const defaultArea = () => {
    if (getUrlParameter('setarea') && areas.includes(getUrlParameter('setarea'))){
        return getUrlParameter('setarea');
    }
    if(process.env.REACT_APP_NODE_ENV !== 'ie' && process.env.REACT_APP_NODE_ENV !== 'test'){
        return AREAS.FINLAND;
    }
    return false;
}


const initialState = {
    area: defaultArea() || undefined,
    showAreaSelect: false,
}


const area = (state = initialState, action) => {
    switch (action.type) {
        case SET_AREA:
        return { ...state, area: action.payload.area, showAreaSelect: action.payload.showAreaSelect }
        case SHOW_AREA_SELECT:
        return { ...state, showAreaSelect: true }
        case HIDE_AREA_SELECT:
        return { ...state, showAreaSelect: false }
        default:
        return state;
    }
};

export { actions };

export default area;



// WEBPACK FOOTER //
// ./src/modules/common/components/areaselect/actions.js